import { render, staticRenderFns } from "./AmountGarbage.vue?vue&type=template&id=5f84c0ee"
import script from "./AmountGarbage.vue?vue&type=script&lang=js"
export * from "./AmountGarbage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports